export const List = () => import("./List.vue");
export const Show = () => import("./Show.vue");
export const Details = () => import("./Details.vue");
export const PropertyGroups = () => import("./PropertyGroups.vue");
export const PropertyItems = () => import("./PropertyItems.vue");
